import React, { useMemo } from "react";

/**
 * Site-wide rising bubbles. Fixed to the viewport so bubbles float
 * up regardless of which section is visible — gives the whole page
 * an underwater feel without re-rendering on scroll.
 *
 * `layer` = "back" (z-0, behind .App content) or "front" (z-30, drifts
 * over content with mix-blend-mode: screen for shimmer).
 */
export default function GlobalBubbles({ count = 22, layer = "back" }) {
  const bubbles = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const sizeBase = layer === "front" ? 14 : 18;
      const sizeRange = layer === "front" ? 60 : 100;
      const size = Math.random() * sizeRange + sizeBase;
      const left = Math.random() * 100;
      const delay = Math.random() * 18;
      const duration = Math.random() * 18 + 14;
      const opacity =
        layer === "front"
          ? Math.random() * 0.35 + 0.35
          : Math.random() * 0.4 + 0.5;
      return { id: i, size, left, delay, duration, opacity };
    });
  }, [count, layer]);

  const isFront = layer === "front";

  return (
    <div
      aria-hidden
      className={`pointer-events-none fixed inset-0 overflow-hidden ${
        isFront ? "z-30" : "z-0"
      }`}
    >
      {bubbles.map((b) => (
        <span
          key={b.id}
          className={`bubble ${isFront ? "bubble-fg" : ""}`}
          style={{
            left: `${b.left}%`,
            bottom: `-${b.size}px`,
            width: `${b.size}px`,
            height: `${b.size}px`,
            opacity: b.opacity,
            animationDuration: `${b.duration}s`,
            animationDelay: `${b.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
